import { render, staticRenderFns } from "./tourGroupDataTable.vue?vue&type=template&id=2f160d58&scoped=true&class=full-height"
import script from "./tourGroupDataTable.vue?vue&type=script&lang=js"
export * from "./tourGroupDataTable.vue?vue&type=script&lang=js"
import style0 from "./tourGroupDataTable.vue?vue&type=style&index=0&id=2f160d58&lang=css"
import style1 from "./tourGroupDataTable.vue?vue&type=style&index=1&id=2f160d58&scoped=true&lang=css"
import style2 from "./tourGroupDataTable.vue?vue&type=style&index=2&id=2f160d58&scoped=true&lang=css"
import style3 from "./tourGroupDataTable.vue?vue&type=style&index=3&id=2f160d58&lang=scss"
import style4 from "./tourGroupDataTable.vue?vue&type=style&index=4&id=2f160d58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f160d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f160d58')) {
      api.createRecord('2f160d58', component.options)
    } else {
      api.reload('2f160d58', component.options)
    }
    module.hot.accept("./tourGroupDataTable.vue?vue&type=template&id=2f160d58&scoped=true&class=full-height", function () {
      api.rerender('2f160d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/travel/components/tourGroupDataTable.vue"
export default component.exports